module.exports = __webpack_public_path__ + "static/img/logo6.8af5d169.png";